import { ToggleButton, ToggleButtonGroup } from "@mui/material";

const ToggleButtons = ({
  value,
  onChange,
  size = "small",
  color = "primary",
  buttons = [],
  disabled = false,
  ...restProps
}) => {
  return (
    <ToggleButtonGroup
      color={color}
      value={value}
      size={size}
      exclusive
      onChange={onChange}
      disabled={disabled}
      {...restProps}
    >
      {buttons.map((buttonProps, index) => (
        <ToggleButton
          key={`button-${index}`}
          color={buttonProps.color}
          value={buttonProps.value}
          className="toggle-group-button"
          {...buttonProps}
        >
          {buttonProps.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default ToggleButtons;
